module.exports = __webpack_public_path__ + "img/btn_watchstamphistory.f0aca610.png";